// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-buttons{width:100%;padding:0.2857142857rem 0}`, "",{"version":3,"sources":["webpack://./app/new-components/DLS/OpForm/FormButtons.scss"],"names":[],"mappings":"AAEA,cACE,UAAA,CACA,yBAAA","sourcesContent":["@use 'assets/scss/common';\n\n.form-buttons {\n  width: 100%;\n  padding: common.toRem(4) 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
